<template>
	<div class="content">
		<div class="top">
			
			<div class="top_info">
				<img src="../../assets/image/mine.png" alt="">
				<div class="top_info_text">
					<div class="top_info_title">欢迎您，{{userinfo.manager_name}}</div>
					<div class="top_info_class">
						<span>班级：第十八期新商科大数据研修班</span>
						<span>联系方式：13876543210</span>
					</div>
				</div>
			</div>
			<div class="top_box">
				<div class="top_item">
					<img src="../../assets/img/home7.png">
					<div class="top_item_r">
						<div class="top_item_num">100</div>
						<div class="top_item_title">班级学生数量</div>
					</div>
				</div>
				<div class="top_item">
					<img src="../../assets/img/home8.png">
					<div class="top_item_r">
						<div class="top_item_num">80</div>
						<div class="top_item_title">平均得分</div>
					</div>
				</div>
				<div class="top_item">
					<img src="../../assets/img/home3.png">
					<div class="top_item_r">
						<div class="top_item_num">100</div>
						<div class="top_item_title">总任务数</div>
					</div>
				</div>
				<div class="top_item">
					<img src="../../assets/img/home4.png">
					<div class="top_item_r">
						<div class="top_item_num">100</div>
						<div class="top_item_title">总作业数</div>
					</div>
				</div>
				<div class="top_item" style="opacity: 0;">
					
				</div>
			</div>
		</div>
		<div class="information">
			<div class="information_item">
				<div class="information_title">实训任务进度</div>
				<div class="jindu">
					<el-progress type="circle" :percentage="60" color="#007AFF" :width="210" :stroke-width="32" stroke-linecap="butt"></el-progress>
				</div>
				<div class="jindu_title">已完任务占比</div>
				<div class="jindu_btm">
					<div class="jindu_btm_item">
						<div style="font-weight: bold;">100</div>
						<div>已完成任务</div>
					</div>
					<div class="jindu_btm_item">
						<div style="font-weight: bold;">100</div>
						<div>总任务数</div>
					</div>
				</div>
			</div>
			<div class="information_item">
				<div class="information_title">课程题库进度</div>
				<div class="jindu">
					<el-progress type="circle" :percentage="70" color="#E98E2D" :width="210" :stroke-width="32" stroke-linecap="butt"></el-progress>
				</div>
				<div class="jindu_title">已完成课程作业占比</div>
				<div class="jindu_btm">
					<div class="jindu_btm_item">
						<div style="font-weight: bold;">100</div>
						<div>已完成课程</div>
					</div>
					<div class="jindu_btm_item">
						<div style="font-weight: bold;">100</div>
						<div>总课程数</div>
					</div>
				</div>
			</div>
			<div class="information_item" style="width: 40%;">
				<div class="information_title">每月练习次数</div>
				<el-table style="width: 100%;margin-top: 38px;" border :data="tableData" :header-cell-style="{background: '#F5F6F7'}">
					<el-table-column prop="orderId" label="月份" align="center"/>
					<el-table-column prop="createDate" label="完成任务数" align="center"/>
					<el-table-column prop="clientCode" label="答题次数" align="center"/>
				</el-table>
				<div class="block" style="margin-top: 20px;text-align: center;">
					<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" layout="prev, pager, next" :total="total"></el-pagination>
				</div>
			</div>
		</div>
		<div class="information">
			<div class="information_hr">实训任务进度</div>
			<div class="infobox">
				<div id="pie" style="width: 100%;height: 450px" ></div>
				<div id="pie1" style="width: 100%;height: 450px" ></div>
				<div id="pie2" style="width: 100%;height: 450px" ></div>
			</div>
		</div>
		<div class="information">
			<div class="information_hr">学生题库答题分数占比</div>
			<div id="zhu" style="width: 100%;height: 650px" ></div>
		</div>
		<div class="information">
			<div class="information_hr">学生题库答题分数占比</div>
			<div style="width: 100%;margin-top: 30px;">
				<el-table style="width: 100%;" border :data="tableData" :header-cell-style="{background: '#F5F6F7'}">
					<el-table-column prop="orderId" label="学号" align="center"/>
					<el-table-column prop="createDate" label="姓名" align="center"/>
					<el-table-column prop="clientCode" label="年级" align="center"/>
					<el-table-column prop="clientCode" label="性别" align="center"/>
					<el-table-column prop="clientCode" label="联系方式" align="center"/>
					<el-table-column  label="操作" align="center">
						<template slot-scope="scope">
							<el-button @click="goDetails(scope.row)" type="text" size="small">学习统计</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="block" style="margin-top: 20px;text-align: center;">
					<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" layout="prev, pager, next" :total="total"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {getInfo} from "../../api/new.js";	
import * as echarts from 'echarts';		
	export default {
		data() {
			return {
				userinfo:'',
				loading: false,
				tableData: [{orderId:'2022.01',createDate:'100',clientCode:'200'}],
				value: new Date(),
				pageSizes: [10, 50, 100, 200],
				pageSize: 10,
				total: 0,
				currentPage: 1,
				opinionZhu:{//柱状图数据
					xAxis: {
						type: "category",
						data: ["39以下", "40-49", "50-59", "60-69", "70-79", "80-89", "90-100"],
					},
					yAxis: { type: "value", },
					series: [
						{
						    data: [120, 200, 150, 80, 150, 80,56],
							type: "bar",
							itemStyle:{
								normal: {
									color: function(params) {
										var colorList = ['#4ED885','#398FED', '#FAB337', '#CCCCCC', '#F1712B','#33D2D4', '#FF45AE'];
										return colorList[params.dataIndex]
									}
								}
							},
							// 实现数字展示在柱状图
							label: {
								show: true,
								position: 'top',
								color:'black',
								// formatter:'{b} : {c} ({d}%)'
							},
						},
						
						
					]
				},
				opinionPie:{//扇形图数据
				    tooltip: {
				        trigger: 'item',
						formatter: '{b} : {c} ({d}%)'
				    },
					title: {
					    text: '及格率',
					    left: 'center'
					},
				    series: [
				        {
				            type: 'pie',
				            radius: '50%',
				            data: [
				                {value: 55, name: '及格'},
				                {value: 45, name: '未及格'},
				            ],
							
				            emphasis: {
				                itemStyle: {
				                    shadowBlur: 10,
				                    shadowOffsetX: 0,
				                    shadowColor: 'rgba(0, 0, 0, 0.5)'
				                }
				            }
				        }
				    ]
				},
			};
		},
		
		mounted() {
			this.getgeInfo()
			var _this = this
			_this.$nextTick(function() {
				_this.drawPie('pie')
				_this.drawPie('pie1')
				_this.drawPie('pie2')
				_this.drawZhu('zhu')
			})
		},
		methods: {
			// 获取个人信息
			getgeInfo() { 
				var _this = this
				getInfo().then((res) => {
					if (res.code == 0) {
						this.userinfo = res.data
					}
				})
				.catch((err) => {
					console.log(err);
				});	
			},
			//扇形图
			drawPie(id) {
				this.charts = echarts.init(document.getElementById(id))
				this.charts.setOption(this.opinionPie)
			},
			//柱形图
			drawZhu(id) {
				this.charts = echarts.init(document.getElementById(id))
				this.charts.setOption(this.opinionZhu)
			},
			goDetails() {
				this.$router.push({
				  path: "/student",
				  query: {
				    id: "1",
				  },
				});
			},
			// 分页
			handleSizeChange(pageSize) {
				this.pageSize = pageSize;
				this.currentPage = 1;
				this.getTableData(this.queryCondition, this.currentPage, this.pageSize);
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getTableData(this.queryCondition, this.currentPage, this.pageSize);
			}
		},
	};
</script>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.content{
	width: 100%;
	min-width: 1200px;
	margin: 0 auto;
	
	.top{
		width: 100%;
		background: #FFFFFF;
		border-radius: 20px;
		padding: 35px 45px;	
		.top_info{
			width: 100%;
			display: flex;
			align-items: center;
			img{
				width: 72px;
				height: 72px;
				border-radius: 50%;
				object-fit: cover;
			}
			.top_info_text{
				margin-left: 22px;
				height: 72px;
				.top_info_title{
					font-size: 24px;
					font-weight: 500;
					color: #333333;
					line-height: 40px;
					// padding: 6px 0 12px 0;
				}
				.top_info_class{
					font-size: 16px;
					color: #333333;
					line-height: 18px;
					margin-top: 8px;
					span{
						margin-right: 120px;
					}
				}
			}
		}
		.top_box{
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 30px;
			.top_item{
				width: 18%;
				// width: 280px;
				
				height: 110px;
				background: #F7F7F7;
				padding-left: 20px;
				display: flex;
				align-items: center;
				cursor: default;
				border-radius: 10px;
				img{
					width: 80px;
					height: 80px;
				}
				.top_item_r{
					height: 80px;
					margin-left: 10px;
					.top_item_num{
						font-size: 36px;
						font-family: DIN;
						font-weight: bold;
						color: #333333;
						line-height: 36px;
						margin-top: 6px;
					}
					.top_item_title{
						font-size: 20px;
						color: #333333;
						line-height: 20px;
						margin-top: 12px;
					}
				}
			}
		}
		
	}
	.information{
		width: 100%;
		background: #FFFFFF;
		border-radius: 20px;
		padding: 35px 45px;	
		margin-top: 40px;
		display: flex;
		flex-wrap: wrap;
		.information_hr{
			width: 100%;
			font-size: 20px;
			font-weight: bold;
			color: #333333;
			line-height: 20px;
		}
		.infobox{
			width: 100%;
			display: flex;
			justify-content: space-between;
			margin-top: 30px;
		}
		.information_item{
			width: 30%;
			.information_title{
				font-size: 20px;
				font-weight: bold;
				color: #333333;
				line-height: 20px;
			}
			.jindu{
				width: 100%;
				display: flex;
				justify-content: center;
				margin-top: 80px;
			}
			.jindu_title{
				font-size: 18px;
				font-family: PingFang SC;
				font-weight: 500;
				line-height: 18px;
				text-align: center;
				margin-top: 34px;
				color: #333333;
			}
			.jindu_btm{
				width: 300px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin: 80px auto;
				.jindu_btm_item{
					text-align: center;
					font-size: 18px;
				}
			}
		}
	}
	
}	
</style>



// WEBPACK FOOTER //
// src/components/index/home.vue